import { type Certificate } from 'common/certificates/certificates.types'
import { type ReactElement } from 'react'

export enum StoreStatus {
  Idle = 'Idle',
  Loading = 'Loading',
  Failed = 'Failed',
  Succeeded = 'Succeeded',
}

export interface UsersSchema {
  allUsers: Array<{
    id: string
    name: string
    group: string
  }>
}

export enum Role {
  admin = 'admin',
  stakeholder = 'stakeholder',
  consultant = 'consultant',
  company = 'company',
  vendor = 'vendor',
}

export enum UserApps {
  Processing = '/programi',
  Company = '/kompanije',
  Reporting = '/izvestaji',
  Vendors = '/vendori',
  Users = '/korisnici',
}

export interface PaginatedResponse<T> {
  count: number
  data: T
}

export enum DrawerSize {
  Large = 275,
  Shrunk = 80,
}

export const HeaderHeight = 73

export enum POPPER_TYPES {
  filter = 'filter',
  navbar = 'navbar',
}

export enum UserStatus {
  active = 'active',
  pending = 'pending',
  disabled = 'disabled',
}

export interface SelectOption {
  id: string
  name: string
}

export interface Category {
  id: string
  name: string
  subcategories: SelectOption[]
}

export interface CustomTab {
  title: string
  content: ReactElement
}

export interface HeaderLink {
  label: string
  route?: string
  nestedRoutes: Array<{ label: string; route: string }> | undefined
  roles: Role[]
  isLinkAllowed?: boolean
}

export interface UserGroup {
  id: string
  photo?: {
    url: string
    expiresIn: number
  }
  name:
    | {
        first: string
        last: string
      }
    | string
  role: Role
  status: UserStatus
  nickname: string
  users?: User[]
  tracked?: {
    count: number
    limit: number
  }
  requested?: {
    count: number
    limit: number
  }
  email?: string
  certificates?: Certificate[]
  aprEmail?: string
}
export interface UserGroupDetails {
  id: string
  photo?: {
    url: string
    expiresIn: number
  }
  name: string
  slug: string
  plan?: Plan
}

export interface Plan {
  period?: {
    from: Date
    to: Date
  }
  tracking: {
    current: number
    max: number
  }
  requests: {
    current: number
    max: number
  }
}
export interface User {
  id: string
  photo?: string
  name: {
    first: string
    last: string
  }
  role: Role
  status: UserStatus
  email: string
  nickname?: string
  companyName?: string
  certificates?: Certificate[]
  isVendor?: boolean
  aprEmail?: string
  companyId?: string
}
export interface GroupUser {
  id: string
  photo?: {
    url: string
    expiresIn: number
  }
  role: Role
  status: UserStatus
  email: string
  nickname?: string
  expiresIn?: number
  name: {
    first: string
    last: string
  }
}

export enum PlanNames {
  basic = 'Osnovni paket',
  silver = 'Srebrni paket',
  gold = 'Zlatni paket',
}

export interface PlanType {
  trackingMax: number
  requestedMax: number
  slug: 'basic' | 'silver' | 'gold'
  title: PlanNames
}

export const Plans: Record<string, PlanType> = {
  basic: {
    trackingMax: 10,
    requestedMax: 20,
    slug: 'basic',
    title: PlanNames.basic,
  },
  silver: {
    trackingMax: 20,
    requestedMax: 40,
    slug: 'silver',
    title: PlanNames.silver,
  },
  gold: {
    trackingMax: 30,
    requestedMax: 60,
    slug: 'gold',
    title: PlanNames.gold,
  },
}

export interface UserInfoData {
  id: string
  email: string
  role: Role
  name?: string
  photo: {
    url: string
    expiresIn: number
  }
  isVendor: boolean
}

export interface Consultant {
  id: string
  name: {
    first: string
    last: string
  }
  certificates: Certificate[]
}
